<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-top">
                    <div class="row">

                        <div class="col-lg-6">
                            <div class="about-enago">
                                <h3>AI英文校正ツールTrinkaについて</h3>
                                <p>
                                    AI搭載の校正ツールTrinka（トリンカ）は、学術論文・テクニカルライティングに特化した文章校正ツールです。利用者のプライバシーに考慮した文法チェック、言語能力向上のためのライティングアシストを提供し、 文脈にそぐわないスペル・表記や高度な文法ミスをリアルタイムで修正します。Trinkaは、専門家や学術関係者の、フォーマルで簡潔、かつ魅力的な文章作成をサポートします。企業向けソリューションTrinka Enterpriseでは、全機能への無制限のアクセスに加え、完全なデータコントロールなどの各種オプションも含め、お客様のニーズに合わせてカスタマイズすることができます。
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="install-in">
                                <h3>プラグインをインストール:</h3>
                                <ul>
                                    <li>
                                        <span class="browser-icon">
                                            <a [routerLink]="['/wordplugin']" routerLinkActive="active" aria-label="word">
                                                <img src="assets/images/NewWordAdd_in.svg" loading="lazy" width="47" height="42" alt="word add in"> </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a [routerLink]="['/wordplugin']" routerLinkActive="active">
                                                <span class="OpenSansFonts">Windows用
                                                    Word<br/>アドイン</span>
                                            </a>
                                        </span>
                                        <!-- <a routerLink="/wordplugin"></a> -->
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a [routerLink]="['/browser-plugin']" routerLinkActive="active" aria-label="chrome">
                                                <img src="assets/images/NewChromeFicon.svg" loading="lazy" width="43" height="42" alt="chrome">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a [routerLink]="['/browser-plugin']" routerLinkActive="active" aria-label="chrome">
                                                <span class="OpenSansFonts">Google Chrome</span>
                                            </a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a [routerLink]="['/browser-plugin']" routerLinkActive="active" aria-label="firefox">
                                                <img src="assets/images/NewFirefoxFicon.svg" loading="lazy" width="45" height="42" alt="firefox">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a [routerLink]="['/browser-plugin']" routerLinkActive="active">
                                                <span class="OpenSansFonts">Mozilla Firefox</span>
                                            </a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a [routerLink]="['/browser-plugin']" routerLinkActive="active" aria-label="edge">
                                                <img src="assets/images/EdgeWhite_BGAndOutline.svg" loading="lazy" width="42" height="42" alt="edge" width="42">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a [routerLink]="['/browser-plugin']" routerLinkActive="active">
                                                <span class="OpenSansFonts">Microsoft Edge</span>
                                            </a>
                                        </span>

                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a href="https://www.trinka.ai/jp/ms-word-addin-for-mac">
                                                <img src="assets/images/NewWordAdd_in.svg" loading="lazy" width="47" height="42" alt="word add-in"> </a>
                                        </span>
                                        <span class="install-in-browser">Mac用Wordアドイン</span>
                                    </li>
                                    <li>
                                        <span class="browser-icon upcoming-icon">
                                            <img src="assets/images/UpcomingSafari_icon.png" loading="lazy" width="66" height="42" alt="safari browser">
                                        </span>
                                        <span class="install-in-browser">
                                            <span class="OpenSansFonts">Safari</span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="contact" id="footerEmailBox">
                                <form class="form-inline" (ngSubmit)="subscribeNow()" [formGroup]="footerFroms">
                                    <div class="form-group mx-sm-3 mb-2 ml-0" [ngClass]="(!footerFroms.get('footeremailform').valid && footerFroms.get('footeremailform').dirty) || (footerFroms.get('footeremailform').touched && footerFroms.get('footeremailform').pristine) ? 'TextFiledError' : '' ">

                                        <mat-form-field appearance="outline">
                                            <mat-label>ニュースレターの配信先アドレス</mat-label>
                                            <input matInput placeholder="" formControlName="footeremailform" class="form-control" name="email">
                                        </mat-form-field>
                                    </div>
                                    <button type="submit" [disabled]="!footerFroms.valid" id="footerSubscribe" class="btn btn-primary mb-2">登録</button>
                                </form>
                            </div>

                        </div>


                    </div>
                    <div class="row">

                        <div class="col-lg-12">
                            <div class="row footer_menu_wrap">
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>
                                            <span class="OpenSansFonts">AI</span>英文校正ツール
                                            <span class="OpenSansFonts">Trinka</span>運営会社</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/aboutus']" routerLinkActive="active">会社概要</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/contactus']" routerLinkActive="active">お問合せ</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/workwithus']" routerLinkActive="active">採用情報</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/affiliates']" routerLinkActive="active">アフィリエイトプログラム</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/accomplishments']" routerLinkActive="active">
                                                    <span class="OpenSansFonts">Accomplishments</span>
                                                </a>
                                            </li> -->
                                        </ul>
                                    </div>
                                    <div class="footer_menu_one">
                                        <h3>もっと詳しく知る</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a href="/case-study/nit"  target="_blank">事例紹介</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/blog/"  target="_blank">Blog</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/examples" routerLinkActive="active">サンプル</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/faqs" routerLinkActive="active">よくあるご質問</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>機能</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/features']" routerLinkActive="active">すべての機能</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/features/grammar-checker" routerLinkActive="active">文法チェッカー</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/plagiarism-check']" routerLinkActive="active">盗用・剽窃チェック</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/features/auto-file-edit" routerLinkActive="active">ファイル自動校正</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/features/latex-grammar-checker" routerLinkActive="active">LaTeXファイル自動校正</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/paraphraser']" routerLinkActive="active">
                                                    不適切な表現のチェック機能
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/features/inclusive-language-check" routerLinkActive="active">
                                                    パラフレーズ機能
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/features/legal-writing" routerLinkActive="active">
                                                    法律文書の英文ライティング
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/features/publication-readiness-checks" routerLinkActive="active">出版適正チェック</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/citation-checker']" routerLinkActive="active">引用チェック</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/consistency-check']" routerLinkActive="active">用語統一チェック</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/personal-dictionary']" routerLinkActive="active">マイ・ディクショナリー</a>
                                            </li>

                                            <li>
                                                <a href="https://www.enago.jp/plagiarism-checker/" target="_blank">剽窃チェック</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/credits']" routerLinkActive="active">Trinkaのポイント</a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3 class="OpenSansFonts">法人向けTrinka Enterprise</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" routerLinkActive="active">ライフサイエンス、医療・医薬</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/language-services-publishing-and-media']" routerLinkActive="active">言語サービス、出版、メディア</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/academic-institutions']" routerLinkActive="active">学術研究機関</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/k12-and-elearning']" routerLinkActive="active">教育 & eラーニング</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/technology-platforms']" routerLinkActive="active">アプリ・CMS・ソフトウェア</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">機関・法人向けTrinka Enterprise</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">文法チェックAPI</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/enterprise/confidential-data-plan-for-grammar-checker" routerLinkActive="active">機密データ保護プラン</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/pricing" routerLinkActive="active">料金</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/local-invoice" routerLinkActive="active">お支払い方法</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/documark']" routerLinkActive="active">DocuMark</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka On-Premise</a>
                                            </li> -->


                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>英文チェッカー比較</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/trinka-vs-grammarly']" routerLinkActive="active">
                                                    <span class="OpenSansFonts">Trinka vs. Grammarly</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-ginger']" routerLinkActive="active">
                                                    <span class="OpenSansFonts">Trinka vs. Ginger</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-languagetool']" routerLinkActive="active">
                                                    <span class="OpenSansFonts">Trinka vs. LanguageTool</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-writefull']" routerLinkActive="active">
                                                    <span class="OpenSansFonts">Trinka vs. Writefull</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']" routerLinkActive="active">解説資料を無料ダウンロードする</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>
                                            <span class="OpenSansFonts">リソース</span></h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/grammar-checker']" routerLinkActive="active">文法チェッカー</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/features/paraphrasing-tool" routerLinkActive="active">パラフレーズツール</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/jp/ai-content-detector" routerLinkActive="active">AI生成コンテンツ検出ツール</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">句読点チェッカー</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/spell-checker']" routerLinkActive="active">スペルチェッカー</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/sentence-checker']" routerLinkActive="active">英文チェッカー</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/english-proofreading-tool']" routerLinkActive="active">英文校正</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="purple-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>お問い合わせは
                        <a href="mailto:support@trinka.ai">
                            <span class="OpenSansFonts">support@trinka.ai</span>
                        </a>まで
                    </p>
                </div>
            </div>
        </div>
    </div> -->
    <div class="footer-separator"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-middle">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="powerd-by">
                                <div class="powered-by-left">
                                    <h3>
                                        <span class="OpenSansFonts">Powered by:</span>
                                    </h3>
                                    <p>
                                        <a href="https://www.enago.jp/" target="_blank" class="footer_logos">
                                            <img src="assets/images/enago-logo.png" alt="エナゴ 英文校正 " width="140" height="40" class="enago logo" />
                                        </a>
                                    </p>
                                </div>
                                <div class="powered-by-right">
                                    <p>エナゴは世界中で論文校正・研究支援サービスを提供しており、現在までに125か国以上の研究者の皆様の研究発表、論文出版をサポートしています。</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="footer_menu_one footer_menu_last">
                                <h3>エナゴ（
                                    <span class="OpenSansFonts">enago</span>）と姉妹部門のサービス</h3>
                                <ul class="ftr-menu">
                                    <li>
                                        <a href="https://www.enago.jp/" target="_blank">英文校正</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.jp/publication-support/" target="_blank">論文投稿支援</a>
                                    </li>
                                    <li>
                                        <a href="https://www.ulatus.jp/" target="_blank">論文翻訳・学術翻訳</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.jp/plagiarism-checker/" target="_blank">剽窃チェッカー</a>
                                    </li>
                                    <li>
                                        <a href="https://www.voxtab.jp/" target="_blank">英語テープ起こし</a>
                                    </li>
                                    <li>
                                        <a href="https://lifesciences.enago.jp/" target="_blank">メディカルコミュニケーション</a>
                                    </li>
                                    <li>
                                        <a href="https://www.read.enago.com/jp/" target="_blank">文献検索・文献管理ツールEnago Read</a>
                                    </li>
                                    <li>
                                        <a href="https://www.crimsonjapan.co.jp/" target="_blank">翻訳会社</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-bottom">
                    <div class="row">
                        <div class="col-md-12 col-lg-7">
                            <p class="OpenSansFonts">© Crimson AI, {{ latestYear }}. Made in India.</p>
                            <ul class="ftr-menu1">
                                <li>
                                    <a href="mailto:support@trinka.ai">
                                        <span class="OpenSansFonts">support@trinka.ai</span>
                                    </a>
                                </li>
                                <li>
                                    <a id="PrivacyButton" href="https://www.trinka.ai/privacypolicy" target="_blank">個人情報保護方針</a>
                                </li>
                                <li>
                                    <a id="termsofserviceButton" href="https://www.trinka.ai/termsofservices" target="_blank">利用規約</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-12 col-lg-5">
                            <div class="follow-us">
                                <h3 class="OpenSansFonts">Follow Us:</h3>
                                <ul class="social-media">
                                    <li>
                                        <a href="https://www.facebook.com/thetrinkaai/" rel=" no referer, no opener" target="_blank" aria-label="facebook">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/thetrinkaai/" rel=" no referer, no opener" target="_blank" aria-label="instagram">
                                            <i class="fa fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://x.com/thetrinkaai" rel=" no referer, no opener" target="_blank" aria-label="twitter">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/thetrinkaai" rel=" no referer, no opener" target="_blank" aria-label="linkedin">
                                            <i class="fa fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA" rel=" no referer, no opener" target="_blank" aria-label="youtube">
                                            <i class="fa fa-youtube-play"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="language_sections" id="languageDropDown">
                                <i class="fa fa-globe" aria-hidden="true"></i>
                                <span>日本語</span>
                                <ul class="drop">
                                    <li>
                                        <a href="https://www.trinka.ai/">English</a>
                                    </li>
                                    <li class="selected">
                                        <a href="https://www.trinka.ai/jp/">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                            日本語
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://trinka.enago.cn/">
                                            简体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/tw/">
                                            繁体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/kr/">
                                            한국어
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/es/">
                                            Español
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<div id="emailSubscribePopup" class="modal fade show" *ngIf="subscribePopup">
	<div class="modal-dialog modal-confirm">
		<div class="modal-content">
			<div class="modal-header flex-column">
				<div class="icon-box">
					<i class="material-icons">&#xE5CA;</i>
				</div>						
				<h4 class="modal-title w-100">Thank you for subscribing to our newsletter</h4>	
                <button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
			</div>
			<div class="modal-body">
                <p>Your subscription has been confirmed.</p>
			</div>
			<div class="modal-footer justify-content-center">
				<button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="btn btn-secondary" data-dismiss="modal">OK</button>
				<!-- <button type="button" class="btn btn-danger">Delete</button> -->
                <p>Note: If at any point of time you wish to opt out from the newsletters, you can simply click on "Unsubscribe" link at the bottom of newsletter.</p>
			</div>
		</div>
	</div>
</div> 
